import React from 'react';
// components
import ToolbarContainer from '../../ui/containers/toolbar-container';
import FlexContainer from '../../ui/containers/flex-container';
import RegularText from '../../ui/texts/regular-text';
import { PremiumInput } from '../../ui/inputs/customInput';
import { withTranslation } from 'react-i18next';

const TicketsListToolbar = ({ filtersData, lastUpdate, t }) => {
  const { internalSelectedFilters, setCreatedAtAfter, setSearch } = filtersData;

  return (
    <ToolbarContainer>
      <FlexContainer>
        {/* crated after */}
        <PremiumInput
          type="date"
          value={internalSelectedFilters.created_at_after}
          label={t('created_after')}
          width="200px"
          onChange={(date) => {
            const newValue = date;
            setCreatedAtAfter(newValue);
          }}
          disableClear={true}
          showCalendarSearchIcon={true}
        />
        {/* search */}
        <PremiumInput
          onChange={(e) => {
            const newValue = e.target.value;
            setSearch(newValue);
          }}
          type="search"
          value={internalSelectedFilters.search}
          label={t('search')}
          width="280px"
        />
      </FlexContainer>
      <FlexContainer>
        {!!lastUpdate && (
          <RegularText>
            {t('last_update')} {lastUpdate}
          </RegularText>
        )}
      </FlexContainer>
    </ToolbarContainer>
  );
};

export default withTranslation('Emergencies')(TicketsListToolbar);
